const ratesData = [
  {
    title: 'Acting Headshots',
    rates: [
      {
        rate: '$150',
        retouches: '1 Retouched Image',
        looks: '1 Look',
        time: '30 Minutes',
      },
      {
        rate: '$200',
        retouches: '2 Retouched Images',
        looks: '1 Look',
        time: '30 Minutes',
      },
      {
        rate: '$300',
        retouches: '4 Retouched Images',
        looks: '1-2 Looks',
        time: '1.5 Hours',
      },
    ]
  },
  {
    title: 'Corporate Headshots',
    rates: [
      {
        rate: '$200',
        retouches: '1 Retouched Image',
        looks: '1 Look',
        time: '30 Minutes',
      },
      {
        rate: '$275',
        retouches: '2 Retouched Images',
        looks: '1 Look',
        time: '30 Minutes',
      },
      {
        rate: '$325',
        retouches: '4 Retouched Images',
        looks: '1-2 Looks',
        time: '1.5 Hours',
      },
    ]
  },
  {
    title: 'Corporate Headshots - Group Rates',
    rates: [
      {
        rate: '$150 / Person',
        people: '2-10 People',
        retouches: '1 Retouched Image',
        looks: '1 Look',
      },
      {
        rate: '$125 / Person',
        people: '11-30 People',
        retouches: '1 Retouched Image',
        looks: '1 Look',
      },
      {
        rate: '$100 / Person',
        people: '31-50 People',
        retouches: '1 Retouched Image',
        looks: '1 Look',
      },
    ]
  },
  {
    title: 'Portraits / Family Portraits / Senior Portraits',
    rates: [
      {
        rate: '$200',
        retouches: '10 Retouched Images',
        looks: '1 Look',
        time: '30 Minutes',
      },
      {
        rate: '$350',
        retouches: '10 Retouched Images',
        looks: '1-2 Looks',
        time: '1.5 Hour',
      },
      {
        rate: '$500',
        retouches: '10 Retouched Images',
        looks: '1-2 Looks / 1-2 Locations',
        time: '2.5 Hours',
      },
    ]
  },
]

export default ratesData
